module.exports = __webpack_public_path__ + "img/kn.7aa3d578.jpg";